<script>
import axios from 'axios';

export default {
    components: {
    },

    props: {
        requisition: {
            type: Object,
            required: true
        },
        jobs: {
            required: false,
            type: Array
        },
        csrfToken: {
            type: String,
            required: true
        },
        defaultApplicant: {
            type: Object,
            required: false
        }
    },

    data() {
        return {
            selectedPhases: [],
            selectedPhase: '',
            applicants : {},
            totalApplicant: 0,
            selectedApplicant: {},
            allPhases: [
                'loading_cv',
                'killer_questions',
                'language_proficiency',
                'telephonic_screening',
                'first_interview',
                'panel_interview',
                'skills_assessment',
                'background_verification',
                'loading_offer',
                'onboarding',
                'start',
            ],
            atsType: this.requisition.person_specification.ats_type,
            selectedApplications: [],
            bulkRecycle: false,
            showSpinner: false,
            currentPage: 1,
            hasMore: true,
            searchTerm: '',
            hasClicked: []
        }
    },

    beforeMount() {
        if (this.requisition.is_pipeline) {
            localStorage.removeItem('Requisitions.selectedPhases')
            this.allPhases = [
                'loading_cv',
                'killer_questions',
                'language_proficiency',
                'telephonic_screening',
                'first_interview',
                'panel_interview',
                'skills_assessment',
                'background_verification',
                'loading_offer',
            ]
        }

        if (this.atsType == 'leadership_and_support') {
            localStorage.removeItem('Requisitions.selectedPhases');
            this.allPhases = [
                'loading_cv',
                'killer_questions',
                'telephonic_screening',
                'first_interview',
                'background_verification',
                'skills_assessment',
                'panel_interview',
                'loading_offer',
                'onboarding',
                'start'
            ];

            if (this.requisition.is_pipeline) {
                localStorage.removeItem('Requisitions.selectedPhases')
                this.allPhases = [
                    'loading_cv',
                    'killer_questions',
                    'telephonic_screening',
                    'first_interview',
                    'background_verification',
                    'skills_assessment',
                    'panel_interview',
                    'loading_offer'
                ]
            }
        }
    },

    mounted() {
        const selectedPhases = localStorage.getItem('Requisitions.selectedPhases')
        this.selectedPhases = selectedPhases == null ? this.allPhases : JSON.parse(selectedPhases)
        //set selectedPhase with the string after # in url
        let phaseUrl = window.location.hash.substring(1);

        if (this.allPhases.includes(phaseUrl)) {
            this.selectedPhase = phaseUrl;
        } else {
            this.selectedPhase = 'loading_cv';
        }

        this.loadPosts();

        if (this.defaultApplicant) {
            this.loadDetail(this.defaultApplicant.id);
        }
    },

    computed: {
        selectedApplicantId() {
            if(this.selectedApplicant.id) {
                return this.selectedApplicant.id;
            }

            return '';
        }
    },
    methods: {
        async loadPosts(clearResult = false) {
            this.$emit('phase-changed', this.selectedPhase);
            this.showSpinner = true;
            try {
                const response = await axios.get(`/ajax/get-requisition-applications/${this.requisition.id}?phase=${this.selectedPhase}&page=${this.currentPage}&searchTerm=${encodeURIComponent(this.searchTerm)}`);
                const data = response.data;

                this.hasMore = data.has_more;

                if (this.selectedPhase == 'loading_cv') {
                    this.totalApplicant = data.applicationsLoadingCv.totalItems;
                } else if (this.selectedPhase == 'killer_questions') {
                    this.totalApplicant = data.applicantsDoingKillerQuestions.totalItems;
                } else if (this.selectedPhase == 'language_proficiency') {
                    this.totalApplicant = data.applicationsInLanguageProfPhase.totalItems;
                } else if (this.selectedPhase == 'telephonic_screening') {
                    this.totalApplicant = data.applicantsInTelephonicScreeningPhase.totalItems;
                } else if (this.selectedPhase == 'first_interview') {
                    this.totalApplicant = data.applicantsInFirstInterviewPhase.totalItems;
                } else if (this.selectedPhase == 'panel_interview') {
                    this.totalApplicant = data.applicantsInPanelInterviewPhase.totalItems;
                } else if (this.selectedPhase == 'skills_assessment') {
                    this.totalApplicant = data.applicantsInSkillsAssessmentPhase.totalItems;
                } else if (this.selectedPhase == 'background_verification') {
                    this.totalApplicant = data.applicantsInBackgroundVerificationPhase.totalItems;
                } else if (this.selectedPhase == 'loading_offer') {
                    this.totalApplicant = data.applicantsInLoadingOfferPhase.totalItems;
                } else if (this.selectedPhase == 'onboarding') {
                    this.totalApplicant = data.applicantsInOnboardingPhase.totalItems;
                } else if (this.selectedPhase == 'start') {
                    this.totalApplicant = data.applicantsInStartPhase.totalItems;
                }

                if (clearResult) {
                    if (this.selectedPhase == 'loading_cv') {
                        this.applicants = data.applicationsLoadingCv.applications;
                    } else if (this.selectedPhase == 'killer_questions') {
                        this.applicants = data.applicantsDoingKillerQuestions.applications;
                    } else if (this.selectedPhase == 'language_proficiency') {
                        this.applicants = data.applicationsInLanguageProfPhase.applications;
                    } else if (this.selectedPhase == 'telephonic_screening') {
                        this.applicants = data.applicantsInTelephonicScreeningPhase.applications;
                    } else if (this.selectedPhase == 'first_interview') {
                        this.applicants = data.applicantsInFirstInterviewPhase.applications;
                    } else if (this.selectedPhase == 'panel_interview') {
                        this.applicants = data.applicantsInPanelInterviewPhase.applications;
                    } else if (this.selectedPhase == 'skills_assessment') {
                        this.applicants = data.applicantsInSkillsAssessmentPhase.applications;
                    } else if (this.selectedPhase == 'background_verification') {
                        this.applicants = data.applicantsInBackgroundVerificationPhase.applications;
                    } else if (this.selectedPhase == 'loading_offer') {
                        this.applicants = data.applicantsInLoadingOfferPhase.applications;
                    } else if (this.selectedPhase == 'onboarding') {
                        this.applicants = data.applicantsInOnboardingPhase.applications;
                    } else if (this.selectedPhase == 'start') {
                        this.applicants = data.applicantsInStartPhase.applications;
                    }

                } else {
                    if (this.selectedPhase == 'loading_cv') {
                        this.applicants = [...this.applicants, ...data.applicationsLoadingCv.applications];
                    } else if (this.selectedPhase == 'killer_questions') {
                        this.applicants = [...this.applicants, ...data.applicantsDoingKillerQuestions.applications];
                    } else if (this.selectedPhase == 'language_proficiency') {
                        this.applicants = [...this.applicants, ...data.applicationsInLanguageProfPhase.applications];
                    } else if (this.selectedPhase == 'telephonic_screening') {
                        this.applicants = [...this.applicants, ...data.applicantsInTelephonicScreeningPhase.applications];
                    } else if (this.selectedPhase == 'first_interview') {
                        this.applicants = [...this.applicants, ...data.applicantsInFirstInterviewPhase.applications];
                    } else if (this.selectedPhase == 'panel_interview') {
                        this.applicants = [...this.applicants, ...data.applicantsInPanelInterviewPhase.applications];
                    } else if (this.selectedPhase == 'skills_assessment') {
                        this.applicants = [...this.applicants, ...data.applicantsInSkillsAssessmentPhase.applications];
                    } else if (this.selectedPhase == 'background_verification') {
                        this.applicants = [...this.applicants, ...data.applicantsInBackgroundVerificationPhase.applications];
                    } else if (this.selectedPhase == 'loading_offer') {
                        this.applicants = [...this.applicants, ...data.applicantsInLoadingOfferPhase.applications];
                    } else if (this.selectedPhase == 'onboarding') {
                        this.applicants = [...this.applicants, ...data.applicantsInOnboardingPhase.applications];
                    } else if (this.selectedPhase == 'start') {
                        this.applicants = [...this.applicants, ...data.applicantsInStartPhase.applications];
                    }
                }

            } catch (error) {
                console.error('Error loading posts:', error);
            } finally {
                this.showSpinner = false;
            }
        },
        loadMore() {
            if (this.hasMore) {
                this.currentPage++;
                this.loadPosts();
            }
        },
        async loadDetail(id) {
            try {
                const applicant = await axios.get(`/recruiter/active-requisitions/applicant/${id}.json`);
                //emit to an event onapplicantloaded
                this.selectedApplicant = applicant.data.jobApplication;

                //push the id to hasClicked array if not already there
                if (!this.hasClicked.includes(id)) {
                    this.hasClicked.push(id);
                }

                this.$emit('applicant-loaded', applicant.data);
            } catch (error) {

            }
        },

        applicationsByPhase(phase) {
            return this.filteredApplications.filter(user => user.application_phase == phase)
        },

        toTitleCase(str) {
            if (this.requisition.is_pipeline) {
                if (str == 'loading_offer') {
                    str = 'passed_background_verification';
                }
            }

            if (this.atsType == 'leadership_and_support') {
                if (str == 'telephonic_screening') {
                    str = 'telephonic_CV_screening';
                }

                if (str == 'skills_assessment') {
                    str = 'psychometric_assessment';
                }
                if (this.requisition.is_pipeline) {
                    if (str == 'loading_offer') {
                        str = 'passed_panel_interview';
                    }
                }
            }

            if(str == 'language_proficiency') {
                str = 'Voice Assessment';
            }

            str = str.split('_').join(' ');

            return str.replace(/\b\w/g, function (word) {
                return word.toUpperCase();
            });
        },
        handleInput() {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(this.fetchData, 500);
        },
        fetchData() {
            this.currentPage = 1;
            this.loadPosts(true)
        },
    }
}
</script>

<template>
    <div class="requisitions-applicants grid-x grid-padding-x grid-padding-y top-margin bg-white border mt-3 applicant-container">
        <div class="cell medium-12">
            <div>
                <label class="filter-label p-2">Applicants</label>
                <select v-model="selectedPhase" class="mt-3" @change="loadPosts(true)">
                    <option v-for="phase in allPhases" :value="phase" :key="phase">{{ phase == 'loading_cv' ? 'Loading CV' : toTitleCase(phase) }}</option>
                </select>

                <div class="search-box mt-3">
                    <input class="long-placeholder" type="text" placeholder="Search candidate (name, surname, ID, etc.)" v-model="searchTerm" @input="handleInput"/>
                    <input class="short-placeholder" type="text" placeholder="Search candidate" v-model="searchTerm" @input="handleInput"/>
                    <i class="fa fa-solid fa-search icon"></i>
                </div>
                <div>
                    <small>Total Applicants: {{ totalApplicant }}</small>
                </div>
            </div>
        </div>
        <div class="small-12">
            <div class="p-2">
                <button class="btn btn-success mycalling-green" @click="loadMore" v-if="hasMore" :disabled="showSpinner">
                    Load More
                </button>
            </div>
            <div class="applicantsList">
                <div class="spinner" v-if="showSpinner">
                    <i class="fa fa-solid fa-spinner fa-spin"></i> Loading....
                </div>
                <div class="applicant-card" :class="{'active': applicant.id === selectedApplicantId, 'clicked': hasClicked.includes(applicant.id)}" v-for="applicant in applicants" :key="`APPLICANT${applicant.id}`" @click="loadDetail(applicant.id)">
                    <h6>{{ applicant.user.full_name }}</h6>
                    <div v-if="applicant.user.user_detail !== null && applicant.user.user_detail.user_detail_jobs[0] !== undefined">
                        <div class="date" v-if="applicant.user.user_detail.user_detail_jobs[0] && applicant.user.user_detail.user_detail_jobs[0].role">
                            {{ applicant.user.user_detail.user_detail_jobs[0].role.title }}
                        </div>
                    </div>
                    <div v-if="applicant.user.baseline_score">
                        Baseline Score: {{applicant.user.baseline_score}}
                    </div>
                </div>
            </div>
            <div class="p-2">
                <button class="btn btn-success mycalling-green" @click="loadMore" v-if="hasMore" :disabled="showSpinner">
                    Load More
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import './assets/scss/frontend/base/colour_vars.scss';

.applicant-container{
    .applicantsList{
        height: 850px;
        overflow-y: auto;

        background-color: white;
        padding: 5px;

        .applicant-card {
            cursor: pointer;
            border-bottom: 1px solid #e0e0e0;
            /* border-radius: 5px; */
            padding: 10px;
            margin-bottom: 5px;
        }

        .active {
            border: 1px solid $green;
            background-color: $green-light;
            color: $dark-gray !important;
            h6 {
                color: $dark-gray !important;
            }
        }

        .clicked {
            color: $gray;
            h6 {
                color: $gray;
            }
        }
    }
}
</style>